export default [
  {
    name: 'BaseChangeSettings',
    path: '/settings/base-changes',
    component: () => import('pages/base-changes/BaseChangeSettings.vue')
  },
  {
    name: 'BaseChangesList',
    path: 'base-changes',
    component: () => import('pages/base-changes/list/BaseChangesList.vue')
  }
]
